import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EventSearchResultComponent } from './event-search-result.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [EventSearchResultComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [EventSearchResultComponent]
})
export class EventSearchResultModule { }
